<template lang="pug">
div(:style="minHeight")

</template>

<script>
import { getMinHeight } from '../../helpers'

export default {
    name: 'SpacerWidget',
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        minHeight() {
            const minHeight = getMinHeight(this.data, this.$device)
            const obj = {}

            if (minHeight) obj.minHeight = `${minHeight}px`
            return obj
        },
    },
}
</script>
